import React from "react";
import Grid from "@mui/material/Grid2";
import Map from "../../assets/images/aboutus-page/location_map.png";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "OurLocation";

const classes = {
  mapImage: `${PREFIX}-mapImage`,
  section: `${PREFIX}-section`,
  sectionTitle: `${PREFIX}-sectionTitle`,
  sectionAddress: `${PREFIX}-sectionAddress`,
  divider: `${PREFIX}-divider`,
  titleContainer: `${PREFIX}-titleContainer`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.mapImage}`]: {
    width: "90%",
    height: "auto",
  },
  [`& .${classes.section}`]: {
    marginBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  [`& .${classes.titleContainer}`]: {
    display: "inline-block",
  },
  [`& .${classes.sectionTitle}`]: {
    fontSize: 30,
    fontWeight: "100",
    marginBottom: theme.spacing(1),
    fontFamily: "AvenirLTStd-Roman",
  },
  [`& .${classes.sectionAddress}`]: {
    fontSize: 18,
    fontFamily: "AvenirLTStd-Book",
    width: "70%",
    padding: 1
  },
  [`& .${classes.divider}`]: {
    borderBottom: "2px solid red",
    width: "20%",
    marginBottom: theme.spacing(1),
    marginBottom: "1rem"
  },
}));

const locations = [
  {
    title: "Ireland",
    address:
      "Regional Development Center,32, DKIT, Dundalk, Co. Louth, A91 RF2W",
  },
  {
    title: "Switzerland",
    address:
      "Integrated Aviation Systems AG Sihleggstrasse 23 8832 Wollerau Switzerland",
  },
  {
    title: "Singapore",
    address: "138, 02-26 Robinson Road, Singapore. ",
  },
  {
    title: "India",
    address: "25, Avinashi Rd, TNHB Colony, Indira Nagar, Civil Aerodrome Post, Coimbatore, Tamil Nadu 641014",
  },
];

function OurLocation() {
  return (
    <StyledGrid container spacing={2}>
      <Grid size={{ xs: 12 }} sx={{display: "flex", justifyContent: "center"}}>
        <img src={Map} className={classes.mapImage} alt="Location Map" />
      </Grid>
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "2rem 2rem 0 2rem",
        }}
      >
        {locations.map((location, index) => (
          <Grid
            key={index}
            size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
            className={classes.section}
          >
            <div className={classes.titleContainer}>
              <Typography variant="h5" className={classes.sectionTitle}>
                {location.title}
              </Typography>
              <div className={classes.divider} />
            </div>
            <Typography variant="body1" className={classes.sectionAddress}>
              {location.address}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </StyledGrid>
  );
}

export default OurLocation;
